import { forwardRef } from 'react'

import type { CSSProp } from '~/types'
import { getFocusRing, useFocusStyle } from '~/utils/focus'
import { isVisualRegressionEnv } from '~/utils/is-visual-regression-env'

import type { Props as BoxProps } from '../box/box'
import { Box } from '../box/box'
import { ConditionalWrapWithTooltip } from '../tooltip-internal/conditional-wrap-with-tooltip'

type Props = BoxProps & {
    tooltip?: string
    loading?: HTMLImageElement['loading']
}

export const Image = forwardRef<HTMLElement, Props>(({ css, tooltip, ...restProps }, ref) => (
    <ConditionalWrapWithTooltip tooltip={tooltip} {...(isVisualRegressionEnv && { visible: true })}>
        <Box
            ref={ref}
            tabIndex={tooltip ? 0 : undefined}
            css={{
                ...css,
                ...getFocusRing(useFocusStyle()),
            } as CSSProp}
            as="img"
            maxWidth="100%"
            {...restProps}
        />
    </ConditionalWrapWithTooltip>
))

Image.displayName = 'Image'
